// extracted by mini-css-extract-plugin
export default {"mainCover":"input_mainCover__CQ8wd","label":"input_label__-b-Hk","inputCover":"input_inputCover__WJ7Y0"};